/**
 * Platform Console — preferencia de sesión del operador de plataforma para
 * ver la app cliente (solo si pertenece a una organización). Por defecto un
 * operador aterriza en /super-admin; abrir la app cliente es una elección
 * explícita desde la consola. Solo UX: el backend sigue siendo la autoridad.
 */
const KEY = 'govia:operator-client-view'

export function setOperatorClientView(enabled: boolean): void {
  try {
    if (enabled) window.sessionStorage.setItem(KEY, '1')
    else window.sessionStorage.removeItem(KEY)
  } catch {
    // Almacenamiento no disponible: se mantiene el comportamiento por defecto.
  }
}

export function hasOperatorClientView(): boolean {
  try {
    return window.sessionStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}
